import { upNavRoutePaths } from "~/constants/upNavRouteConfig.ts";
export function IsUnauthenticatedRoute(route: string) {
  const unauthenticatedRoutes = [
    "/password/edit",
    "/expired",
    "/logout",
    "/no-access",
    upNavRoutePaths.mentionUpsell.path,
  ];

  const normalizedRoute = route.split("?")[0].split("#")[0];
  return unauthenticatedRoutes.includes(normalizedRoute);
}
